import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  BokkzAlgDataService, ClientEntity,
  IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-alimentatie',
  templateUrl: './alimentatie.component.html',
  styleUrls: ['./alimentatie.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class AlimentatieComponent implements OnInit {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;

    private isSaving = false;

    @Input() public id!: string;

    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private client={} as ClientEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    private focusedElementId: string | null = null;

    public alimentatie = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService, private router: Router,private fb: FormBuilder) {
        this.alimentatie = this.fb.group({
            ontvangenAlimentatie: this.fb.array<OmschrijvingEnBedrag>([]),
            aftrekbareKostenAlimentatie: this.fb.array<OmschrijvingEnBedrag>([]),
        })
    }

    get ontvangenAlimentatie(): FormArray {
        return this.alimentatie.get("ontvangenAlimentatie") as FormArray;
    }

    get aftrekbareKostenAlimentatie(): FormArray {
        return this.alimentatie.get("aftrekbareKostenAlimentatie") as FormArray;
    }

    addRijOntvangenAli(): void {
        this.ontvangenAlimentatie.push(this.createAlimentatieOntvangenFormGroup()
        )
    }

    addRijKostenAli(): void {
        this.aftrekbareKostenAlimentatie.push(this.createAlimentatieKostenFormGroup()
        )
    }

    verwijderRijOntvangenAli(index: number): void {
        this.ontvangenAlimentatie.removeAt(index);
        this.alimentatie.updateValueAndValidity()
        this.alimentatie.markAsDirty()
        if (this.ontvangenAlimentatie.length === 0) {
            this.alimentatie.setControl('ontvangenAlimentatie', this.fb.array([]));
        }
        this.saveForm();
    }

    verwijderRijKostenAli(index: number): void {
        this.aftrekbareKostenAlimentatie.removeAt(index);
        this.alimentatie.updateValueAndValidity()
        this.alimentatie.markAsDirty()
        if (this.aftrekbareKostenAlimentatie.length === 0) {
            this.alimentatie.setControl('aftrekbareKostenAlimentatie', this.fb.array([]));
        }
        this.saveForm();
    }



    createAlimentatieOntvangenFormGroup(alimentatie?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: alimentatie ? alimentatie.omschrijving : undefined,
            bedrag: alimentatie ? alimentatie.bedrag : 0
        } as OmschrijvingEnBedrag))
    }

    createAlimentatieKostenFormGroup(alimentatieKosten?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: alimentatieKosten ? alimentatieKosten.omschrijving : undefined,
            bedrag: alimentatieKosten ? alimentatieKosten.bedrag : undefined
        } as OmschrijvingEnBedrag))
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.alimentatie.reset()
                    this.updateForm();
                });
            }
        });
        this.dataAlgService.client.subscribe((client)=> {
          this.client=client
        })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.client.sstRelationId!, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.alimentatie.dirty;
  }

    private updateForm(): void {
        // update ontvangen alimentatie
        let alimentatieOntvangenLijst = this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.ontvangenAlimentatie || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                alimentatieOntvangenLijst = this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.ontvangenAlimentatie || [];
            }
        });

        const formArray = this.alimentatie.get('ontvangenAlimentatie') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
        while (formArray.length > alimentatieOntvangenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }
        for (let i = 0; i < alimentatieOntvangenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(alimentatieOntvangenLijst[i]);
            } else {
                const formGroup = this.createAlimentatieOntvangenFormGroup(alimentatieOntvangenLijst[i]);
                formArray.push(formGroup);
            }
        }
        // update kosten alimentatie
        let alimentatieKostenLijst = this.aangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenAlimentatie || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                alimentatieKostenLijst = this.aangifte?.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.aftrekbareKostenAlimentatie || [];
            }
        });
        const formArrayKosten = this.alimentatie.get('aftrekbareKostenAlimentatie') as FormArray;
        while (formArrayKosten.length > alimentatieKostenLijst.length) {
            formArrayKosten.removeAt(formArrayKosten.length - 1);
        }
        for (let i = 0; i < alimentatieKostenLijst.length; i++) {
            if (i < formArrayKosten.length) {
                const control = formArrayKosten.at(i) as FormGroup;
                control.patchValue(alimentatieKostenLijst[i]);
            } else {
                const formGroupKosten = this.createAlimentatieKostenFormGroup(alimentatieKostenLijst[i]);
                formArrayKosten.push(formGroupKosten);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    belastbarePeriodiekeUitkeringenEnVerstrekkingen: {
                        ...this.aangifte.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen,
                        ontvangenAlimentatie: this.alimentatie.value.ontvangenAlimentatie.length ? this.alimentatie.value.ontvangenAlimentatie : undefined,
                        aftrekbareKostenAlimentatie: this.alimentatie.value.aftrekbareKostenAlimentatie.length ? this.alimentatie.value.aftrekbareKostenAlimentatie : undefined,
                    }
                }
            } as Aangifte;
            if (this.aangifte && this.aangifte.box1) {
                this.aangifte.box1.belastbarePeriodiekeUitkeringenEnVerstrekkingen = undefined;
            }
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.box1,
                        belastbarePeriodiekeUitkeringenEnVerstrekkingen: {
                            ...this.aangifte.partnerAangifte?.box1?.belastbarePeriodiekeUitkeringenEnVerstrekkingen,
                            ontvangenAlimentatie: this.alimentatie.value.ontvangenAlimentatie.length ? this.alimentatie.value.ontvangenAlimentatie : undefined,
                            aftrekbareKostenAlimentatie: this.alimentatie.value.aftrekbareKostenAlimentatie.length ? this.alimentatie.value.aftrekbareKostenAlimentatie : undefined,
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
        this.alimentatie.markAsDirty()
    }
}
